import moment from 'moment';

import dateFormats from 'Constants/date-formats';

export const getDateString = (value) => {
    const date = moment(value);

    return value && date.isValid() ? date.format(dateFormats.default) : null;
};
